export default __webpack_public_path__ + "static/media/ic_section_workout.0bd986b5.svg";